import { relations, sql } from 'drizzle-orm';
import { index, integer, jsonb, pgEnum, pgTable, text, uniqueIndex } from 'drizzle-orm/pg-core';
import * as z from 'zod';
import { user } from './auth.js';
import { timestamps } from './utils/index.js';
import { userActions } from './utils/user-actions.js';
import { uuidv7 } from './utils/uuidv7.js';
/** The Reports tab a view belongs to. */
export const ReportTab = z.enum(['prescriptions', 'stockMovements']);
export const reportTabEnum = pgEnum('report_tab', [ReportTab.enum.prescriptions, ReportTab.enum.stockMovements]);
/**
 * A view is a saved combination of filters and columns, shared by everyone who can open Reports
 * (CY-85). One list per tab; `position` is the shared order within the tab. Rows are never stored.
 */
export const reportViews = pgTable('report_views', {
    id: uuidv7('id').primaryKey(),
    tab: reportTabEnum('tab').notNull(),
    name: text('name').notNull(),
    // Every filter of the tab (date basis and period included); normalized over the defaults on read.
    filters: jsonb('filters').$type().notNull(),
    // The column ids shown when the view was saved, in order.
    fieldIds: jsonb('field_ids').$type().notNull(),
    position: integer('position').notNull(),
    ...userActions(),
    ...timestamps(),
}, t => [
    index('idx_report_views_tab_position').on(t.tab, t.position),
    uniqueIndex('idx_report_views_tab_name')
        .on(t.tab, t.name)
        .where(sql `deleted_at IS NULL`),
]);
export const reportViewsRelations = relations(reportViews, ({ one }) => ({
    created: one(user, { fields: [reportViews.createdBy], references: [user.id] }),
    updated: one(user, { fields: [reportViews.updatedBy], references: [user.id] }),
}));
//# sourceMappingURL=reports.js.map